import { Card, CardContent, Typography, Box } from '@mui/material';
import { AccountBalance as AccountBalanceIcon } from '@mui/icons-material';

export function UserPaymentDetailsEmptyCard() {
  return (
    <Card variant="outlined" data-testid="user-payment-details-empty-card">
      <CardContent>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <AccountBalanceIcon fontSize="small" color="action" />
          <Typography variant="h6" component="h3">
            Payment Details
          </Typography>
        </Box>
        <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>
          No payment details provided yet
        </Typography>
      </CardContent>
    </Card>
  );
}
